import React, { useContext } from 'react';
import MapContext from '../../../../containers/Map/MapContext';
import ProgressIndicator from '../../ProgressIndicator';

import './style.scss';

const dayNames = [
  'Zondag',
  'Maandag',
  'Dinsdag',
  'Woensdag',
  'Donderdag',
  'Vrijdag',
  'Zaterdag',
];

const MAX_DISPLAY_DISTANCE = 500000;

const SearchItem = ({ item }) => {
  const fieldActivityDatetime = item.fields.field_activity_datetime && item.fields.field_activity_datetime[0];
  const endValue = item.fields.end_value && item.fields.end_value[0];
  const fieldMaxVolunteers = item.fields.field_max_volunteers && item.fields.field_max_volunteers[0];
  const placesAvailable = item.fields.places_available && item.fields.places_available[0];
  const projectType = item.fields.project_type_name ? item.fields.project_type_name[0] : 'Flag';

  const dateStart = new Date(fieldActivityDatetime * 1000);
  const dateEnd = new Date(endValue * 1000);
  const iconClass = `icon-${projectType.toLowerCase()}`;
  const progress = (parseFloat(fieldMaxVolunteers) - parseFloat(placesAvailable)) / parseFloat(fieldMaxVolunteers);
  const { setSelectedProject } = useContext(MapContext);

  return (
    <article
      className="SearchItem"
      onMouseOver={() => setSelectedProject(item.id)}
    >
      <div className="row">
        <div className="SearchItem__buttonwrapper col-4">
          <i className={`icon icon-project-default ${iconClass} icon--large`} />
          <a className={`Button Button--primary ${item.fields.field_project_full[0] ? 'disabled' : ''}`} href={item.fields.url[0]}>Meld je aan</a>
          <div className="SearchItem__status">
            <ProgressIndicator progress={progress} />
            <div className="SearchItem__availability">
              {item.fields.field_project_full[0] === true
                ? <span>Dit project is vol</span>
                : <span>{item.fields.places_available[0]} / {item.fields.field_max_volunteers[0]} beschikbaar</span>}
            </div>
          </div>
        </div>
        <div className="col-8 SearchItem__info">
          <h2>
            <a href={item.fields.url[0]}>{item.fields.title[0]}</a>
          </h2>
          <div className="SearchItem__date">
            <div>
              <span className="SearchItem__date">
                {dayNames[dateStart.getDay()]}
                &nbsp;
                {dateStart.getDate()}-{(dateStart.getMonth() + 1).toString().padStart(2, '0')}-{dateStart.getFullYear()}
                ,
                &nbsp;
              </span>
              <span className="SearchItem__date__time">
                {dateStart.getHours().toString().padStart(2, '0')}:{dateStart.getMinutes().toString().padStart(2, '0')}
                &nbsp;-&nbsp;
                {dateEnd.getHours().toString().padStart(2, '0')}:{dateEnd.getMinutes().toString().padStart(2, '0')}
              </span>
            </div>
          </div>
          <div className="SearchItem__location">{item.fields.address_line1[0]}, {item.fields.locality[0]}</div>
          {item.distance && item.distance < MAX_DISPLAY_DISTANCE && <div className="SearchItem__distance"><span>{parseInt(item.distance / 1000)} km</span></div>}
        </div>
      </div>
    </article>
  );
};

export default SearchItem;
